import React, { useState, useEffect, useCallback } from "react";
import {
  CommonHeader,
  Loader,
  ErrorSuccessModal,
} from "../../../components/commons";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { JobProgressTable } from "../../../components/AdminReports";
import {
  DocumentsLinkType,
  JobProgressCommentType
} from "../../../redux/listing/listingTypes";
import { JOB_PROGRESS_HEADERS } from "../../../constant/tableHeadersConstants/jobProgressHeaderConst";
import ProgressCommentsModal from "../../../components/JobListing/ProgressCommentsModal";
import {
  AddDocumentLinkPayloadType,
  AddJobProgressCommentPayload,
  GetAllDocumentsLinkPayloadType,
  GetJobProgressCommentsPayload,
} from "../../../commonTypes/listing";
import { resetSession } from "../../../redux/auth";
import LinkUploadModal from "../../../components/JobListing/LinkUploadModal";
import toast, { Toaster } from "react-hot-toast";
import { SearchIcon } from "../../../components/Icon";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import JobProgressFilter, { JOB_STATUS_RADIO_OPTIONS } from "../../../components/AdminReports/JobProgress/JobProgressFilter";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import MultiSelect from "../../../components/commons/MultiSelect";
import { addJobCommentsAction, addJobLinkAction, getJobCommentsDetailsAction, getJobLinksDetailsAction, getSingleJobsAction, resetDocumentsLinkList, resetJobProgressCommentsListing, resetJobProgressCommentsSuccess, resetJobsTotalCount, resetSingleJobs } from "../../../redux/jobs";
import { getJobsListAction, resetError, resetJobsList, resetSuccess } from "../../../redux/jobs";
import ShowUsersWorkingOnJobModal from "../../../components/JobListing/ShowUserWorkingJobModal";
import ShowShareJobModal from "../../../components/JobListing/ShareJobsModal/index";
import { SingleJobPayload } from "../../../commonTypes/jobsType";
import JobsSorting from "../../Jobs/Jobs/FilterAndShorting/JobsSorting";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import JobProgressDownloadReport from "../../../components/AdminReports/JobProgress/JobProgressDownloadReport";

type AppProps = {
  fetching: boolean;
  token: string | null;
  statusCode: number | null;
  success: number | null;
  error: string | null | undefined;
  openJobsListing: any[] | [];
  documentsLinkList: [] | DocumentsLinkType[];
  jobProgressCommentsFetching: boolean;
  jobProgressCommentsList: [] | JobProgressCommentType[];
  jobProgressCommentsSuccess: number | null;
  singleJobsData: any;
  dispatchResetSession: () => void;
  dispatchResetListingError: () => void;
  dispatchResetListingSuccess: () => void;
  dispatchResetOpenJobsList: () => void;
  dispatchGetAllOpenJobsListAction: (data: any) => void;
  dispatchResetJobProgressCommentsListing: () => void;
  dispatchResetJobProgressCommentsSuccess: () => void;
  dispatchGetAllJobProgressCommentsAction: (
    data: GetJobProgressCommentsPayload
  ) => void;
  dispatchAddDocumentLinkAction: (data: AddDocumentLinkPayloadType) => void;
  dispatchGetDocumentsLinkAction: (
    data: GetAllDocumentsLinkPayloadType
  ) => void;
  dispatchGetSingleJobsAction: (data: SingleJobPayload) => void;
  dispatchResetDocumentsLinkList: () => void;
  openJobsListingTotalCount: string | number;
  dispatchResetAllOpenItemsListTotelCount: () => void;
  dispatchResetsingleJobsAction: () => void;
  dispatchAddJobProgressCommentAction: (data: AddJobProgressCommentPayload) => void;

};

export type SortType={
   name: string;
   value: string; 
  }


const JobProgressReports = ({
  fetching,
  token,
  success,
  error,
  statusCode,
  openJobsListing,
  singleJobsData,
  jobProgressCommentsFetching,
  jobProgressCommentsList,
  dispatchResetOpenJobsList,
  dispatchResetListingSuccess,
  dispatchResetListingError,
  dispatchGetAllOpenJobsListAction,
  dispatchGetAllJobProgressCommentsAction,
  dispatchAddDocumentLinkAction,
  dispatchGetDocumentsLinkAction,
  dispatchResetSession,
  documentsLinkList,
  jobProgressCommentsSuccess,
  dispatchGetSingleJobsAction,
  dispatchResetJobProgressCommentsSuccess,
  dispatchResetDocumentsLinkList,
  openJobsListingTotalCount,
  dispatchResetAllOpenItemsListTotelCount,
  dispatchResetsingleJobsAction,
  dispatchAddJobProgressCommentAction
}: AppProps) => {
  const [showProgressCommentsModal, setShowProgressCommentsModal] =
    useState<boolean>(false);
  const [jobProgressComment, setJobProgressComments] = useState<
    JobProgressCommentType[] | []
  >([]);
  const [multiSelectData, setMultiSelectData] = useState<any>([]);
  const [isMultiSelectPresent, setIsMultiSelectPresent] =
    useState<boolean>(false);
  const [openStatus, setOpenStatus] = useState("")
  const [openStatusValue, setOpenStatusValue] = useState<string>("");
  const [jobsData, setJobsData] = useState<any | null>(null);
  const [showLinkUploadModal, setShowLinkUploadModal] = useState<boolean>(false);
  const [showUsersWorkingOnJob, setShowUserWorkingOnJob] = useState<boolean>(false)
  const [showShareJobsModal, setShowShareJobsModal] = useState<boolean>(false)
  const [jobId, setJobId] = useState<number>(0);
  const [modalType, setModalType] = useState<string>("");
  const [searchData, setSearchData] = useState("");
  const getPage = 'job-Progress-Open-Jobs';
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<[] | any>([])
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [jobTypeId, setJobTypeId] = useState("")
  const [showUsersWorkingOnJobData, setShowUsersWorkingOnJobData] = useState(null);
  const [toggleSort, setToggleSort] = useState<boolean>(false)
  const [sortByTargetEndDate, setSortByTargetEndDate] = useState({ name: "", value: "" })
  const [sortByJobType, setSortByTargetJobType] = useState({ name: "", value: "" })
  const [sortByStatus, setSortByStatus] = useState({ name: "", value: "" })
  const [sortByClientCode, setSortByClientCode] = useState({ name: "", value: "" })
  const [sortByClientName, setSortByClientName] = useState({ name: "", value: "" })
  const [recently, setRecently] = useState({ name: "", value: "" })
  const [commentState, setCommentState] = useState<boolean>(false);
  const [jobPriority , setJobPriority] = useState({
    value:null,
    label:"Select.."
  })

  useEffect(() => {
    dispatchResetListingError();
    dispatchResetListingSuccess();
    dispatchResetOpenJobsList();
    dispatchResetAllOpenItemsListTotelCount();
    dispatchResetsingleJobsAction();
    dispatchResetJobProgressCommentsSuccess();
  }, []);

  const fetchNewData = (search?: string) => {
    if (token) {
      let finalData = {
        token,
        search_term: search
          ? search
          : searchData 
            ? searchData
            : "",
        offset,
        limit,
        filterStatus: openStatus,
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        status: sortByStatus?.value,
        sortByClientCode:sortByClientCode?.value,
        clientName:sortByClientName?.value,
        jobPriority:jobPriority?.value
      };
      if (offset === 0) {
        dispatchGetAllOpenJobsListAction(finalData);
      }
      else {
        setOffset(0)
      }
    }
    dispatchResetListingError();
    dispatchResetListingSuccess();
  };

  useEffect(() => {
    dispatchResetJobProgressCommentsSuccess();
    if (token) {
      let finalData = {
        token,
        limit,
        offset,
        search_term: searchData,
        filterStatus: openStatus,
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        status: sortByStatus?.value,
        sortByClientCode:sortByClientCode?.value,
        clientName:sortByClientName?.value,
        jobPriority:jobPriority?.value

      };
      if (clearFilter) {
        finalData.filterStatus = "";
        setOpenStatus("");
        setOpenStatusValue("");
        setClearFilter(false);
        setJobPriority({
          value: null,
          label: "Select..",
        });
      }
      if (offset < +openJobsListingTotalCount) {
        dispatchGetAllOpenJobsListAction(finalData);
      }
      else if (offset === 0 && openJobsListingTotalCount === 0) {
        dispatchResetOpenJobsList();
        dispatchGetAllOpenJobsListAction(finalData);
      }
    }
  }, [offset, clearFilter])

  useEffect(() => {
    if(searchData){
      dispatchResetOpenJobsList();
    }
    
    const delayDebounceFn = setTimeout(() => {
      if (searchData) {
        fetchNewData(searchData);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchData]);

  useEffect(() => {
    if (openJobsListing?.length === 0) {
      setData(openJobsListing)
    }
    if (offset > 0) {

      setData((prv: any) => [...prv, ...openJobsListing])
    }
    else {

      setData(openJobsListing)
    }

  }, [openJobsListing]);


  // 
  useEffect(() => {
    dispatchResetOpenJobsList();
    dispatchResetAllOpenItemsListTotelCount()

    getData();
    setOffset(0);
    setIsMultiSelectPresent(true);
    if (
      (openStatus && isMultiSelectPresent) ||
      (!openStatus && isMultiSelectPresent)
    ) {
      if (offset === 0 && token) {

        let finalData = {
          token,
          limit,
          offset,
          search_term: searchData,
          filterStatus: openStatus,
          endDate: sortByTargetEndDate?.value,
          jobType: sortByJobType?.value,
          status: sortByStatus?.value,
          sortByClientCode:sortByClientCode?.value,
          clientName:sortByClientName?.value,
          jobPriority:jobPriority?.value

          
        };
        dispatchGetAllOpenJobsListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  }, [openStatus]);

  useEffect(()=>{

  })
  const handleSubmit = () => {
    dispatchResetOpenJobsList();
    dispatchResetAllOpenItemsListTotelCount()
    setOffset(0);
    setOpenStatus(openStatusValue);
    setClearFilter(false);
    if(token && jobPriority?.value  || openStatus){

    if (offset === 0 && token) {

      let finalData = {
        token,
        limit,
        offset,
        search_term: searchData,
        filterStatus: openStatus,
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        status: sortByStatus?.value,
        sortByClientCode:sortByClientCode?.value,
        clientName:sortByClientName?.value,
        jobPriority:jobPriority?.value

        
      };
      dispatchGetAllOpenJobsListAction(finalData);
    } else {
      setOffset(0);
    }
  }

  };

  const getData = useCallback(() => {
    setOffset(0);
    const getJobStatusValue = JOB_STATUS_RADIO_OPTIONS.find(
      (item: RadioTypes) => String(item.id) === String(openStatus)
    );
    setMultiSelectData([getJobStatusValue]);
  }, [openStatus]);

  const handleSearch = (e: any) => {
    if(searchData){
      dispatchResetOpenJobsList();
    }
    
    let value = e.target.value;
    setSearchData(value);
    if (value?.length === 0) {
      let finalData = {
        token,
        limit,
        offset: 0,
        search_term: "",
        filterStatus: openStatus,
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        status: sortByStatus?.value,
        sortByClientCode:sortByClientCode?.value,
        clientName:sortByClientName?.value,
        jobPriority:jobPriority?.value

      };
      dispatchGetAllOpenJobsListAction(finalData);
    }
  };

  const onScroll = () => {
    if (!fetching) {

      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +openJobsListingTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (openJobsListing?.length > 0) {
          if (!fetching && offset < +openJobsListingTotalCount) {
            setOffset(offset + limit);
          }
        }
      }

    }
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [openJobsListing]);

  useEffect(() => {
    if (jobProgressCommentsList) {
      setJobProgressComments(jobProgressCommentsList);
    }
  }, [jobProgressCommentsList]);


  useEffect(() => {
    dispatchResetListingError();
    dispatchResetListingSuccess();
    dispatchResetOpenJobsList();
    dispatchResetAllOpenItemsListTotelCount()
    dispatchResetsingleJobsAction()
    setOffset(0)
    if (token && ((sortByTargetEndDate?.name) || (sortByJobType?.name) || (sortByStatus?.name) || (sortByClientCode?.name) || (sortByClientName?.name)  || (recently?.name))) {
      let finalData = {
        token,
        limit,
        offset: 0,
        search_term: searchData,
        filterStatus: openStatus,
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        status: sortByStatus?.value,
        sortByClientCode:sortByClientCode?.value,
        clientName:sortByClientName?.value,
        jobPriority:jobPriority?.value

      };
        dispatchGetAllOpenJobsListAction(finalData);
    }
}, [sortByTargetEndDate, sortByJobType, sortByStatus, recently, sortByClientCode,sortByClientName])

  const handleToggleProgressCommentsModal = () => {
    setShowProgressCommentsModal(!showProgressCommentsModal);
    if(commentState && offset===0){
      let finalData = {
        token,
        limit,
        offset: 0,
        search_term: searchData,
        filterStatus: openStatus,
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        status: sortByStatus?.value,
        sortByClientCode:sortByClientCode?.value,
        clientName:sortByClientName?.value,
        jobPriority:jobPriority?.value

      };
        dispatchGetAllOpenJobsListAction(finalData);

    } else if (commentState && offset!==0){
      setOffset(0)
    }
  };

  const handleToggleLinkUploadModal = () => {
    setOffset(0)
    setShowLinkUploadModal(!showLinkUploadModal)
  };

  const handleSorting = (data: any) => {
    if (data?.name === "Target End Date - Ascending" || data?.name === "Target End Date - Descending") {
        setSortByTargetEndDate(data)
        setSortByTargetJobType({ name: "", value: "" })
        setSortByClientName({ name: "", value: "" })
        setSortByClientCode({ name: "", value: "" })
        setSortByStatus({ name: "", value: "" })
        setRecently({ name: "", value: "" })

    }
    else if (data?.name === "Client - A to Z" || data?.name === "Client - Z to A") {
        setSortByClientName(data)
        setSortByTargetEndDate({ name: "", value: "" })
        setSortByTargetJobType({ name: "", value: "" })
        setSortByStatus({ name: "", value: "" })
        setSortByClientCode({ name: "", value: "" })
        setRecently({ name: "", value: "" })
    }
    else if (data?.name === "Client Code - Ascending" || data?.name === "Client Code - Descending") {
        setSortByClientCode(data)
        setSortByTargetEndDate({ name: "", value: "" })
        setSortByTargetJobType({ name: "", value: "" })
        setSortByStatus({ name: "", value: "" })
        setSortByClientName({ name: "", value: "" })
        setRecently({ name: "", value: "" })
    }
    else if (data?.name === "Job Type - A to Z" || data?.name === "Job Type - Z to A") {
        setSortByTargetJobType(data)
        setSortByTargetEndDate({ name: "", value: "" })
        setSortByClientName({ name: "", value: "" })
        setSortByClientCode({ name: "", value: "" })
        setSortByStatus({ name: "", value: "" })
        setRecently({ name: "", value: "" })
    }
    else if (data?.name === "Jobs with Open Status First") {
        setSortByStatus(data)
        setSortByTargetEndDate({ name: "", value: "" })
        setSortByClientName({ name: "", value: "" })
        setSortByClientCode({ name: "", value: "" })
        setSortByTargetJobType({ name: "", value: "" })
        setRecently({ name: "", value: "" })
    }
    else {
        setRecently(data)
        setSortByStatus({ name: "", value: "" })
        setSortByTargetEndDate({ name: "", value: "" })
        setSortByClientName({ name: "", value: "" })
        setSortByClientCode({ name: "", value: "" })
        setSortByTargetJobType({ name: "", value: "" })
    }
}

  const handleSetJobsData = (data: any, type: string) => {
    setJobProgressComments([]);
    setJobsData(data);
    setJobId(data?._id);
    setModalType(type);

    if (type === "comments") {
      let finalData: GetJobProgressCommentsPayload = {
        job_id: data?._id,
        token,
      };

      dispatchGetAllJobProgressCommentsAction(finalData);
    } else if (type === "documents") {
      dispatchResetDocumentsLinkList();
      let finalData: GetAllDocumentsLinkPayloadType = {
        job_id: data?._id,
        token,
      };

      dispatchGetDocumentsLinkAction(finalData);
    }
  };

  const handleSubmitDocumentLink = (data: AddDocumentLinkPayloadType) => {
    let finalData: AddDocumentLinkPayloadType = {
      link: data?.link,
      token,
      job_id: data?.job_id,
      description: data?.description,
    };

    dispatchAddDocumentLinkAction(finalData);
  };

  const onClose = (id: any) => {
    setOffset(0);
    const checkJobStatusValue = JOB_STATUS_RADIO_OPTIONS.find(
      (item: RadioTypes) => item._id == id
    );
    if (checkJobStatusValue) {
      setOpenStatus("");
      setOpenStatusValue("");
    }
  };
  const handleToggleUserWorkingOnJob = () => {
    setShowUserWorkingOnJob(!showUsersWorkingOnJob)

  }
  const getJobId = (data: any) => {
    setShowUsersWorkingOnJobData(data)
    setShowUserWorkingOnJob(!showUsersWorkingOnJob)
    setJobTypeId(data?.job_id)


  }

  const handleToggleShareJobModal = () => {
    setShowShareJobsModal(!showShareJobsModal)

  }
  const handleSubmitJobComment = (data: any) => {
    setCommentState(true);
    let finalData: AddJobProgressCommentPayload = {
        job_id: data?.id,
        comment: data?.commentText,
        token
    };
    dispatchAddJobProgressCommentAction(finalData);
};
  const getShareJobId = (data: any) => {
    setShowUsersWorkingOnJobData(data)
    setShowShareJobsModal(!showShareJobsModal)
    setJobTypeId(data?.job_id)
    if (token && data?.job_id) {
      const finalData = {
        token,
        id: data?._id
      }
      dispatchGetSingleJobsAction(finalData)
    }

  }
  const handleErrorSuccessModal = () => {
    if (jobProgressCommentsSuccess === 0 || success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetListingError();
            }}
          />
        );
      }
    }
    if (jobProgressCommentsSuccess === 1) {
      dispatchResetJobProgressCommentsSuccess();
      if (modalType === "comments") {
        toast.success("Comment Added Successfully!", {
          duration: 2000,
        });

        let finalData: GetJobProgressCommentsPayload = {
          job_id: jobId,
          token,
        };

        dispatchGetAllJobProgressCommentsAction(finalData);
      } else if (modalType === "documents") {
        toast.success("Document Link Added Successfully!", {
          duration: 2000,
        });

        let finalData: GetAllDocumentsLinkPayloadType = {
          job_id: jobId,
          token,
        };

        dispatchGetDocumentsLinkAction(finalData);
        dispatchResetJobProgressCommentsSuccess();
      }
    }

    return false;
  };


  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader
          title={`All Job Progress`}
        />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className='header'>
            <div className="left-header">
              <div className="heading">All Job Progress List</div>
              {!fetching && <div className="sub-heading" style={{ marginTop: "-22px" }}>{`Total ${openJobsListingTotalCount ? openJobsListingTotalCount : 0
                } entries found`}</div>}
              <div><MultiSelect data={multiSelectData} onClose={onClose} /> </div>
            </div>
            <div
              className="text-right d-flex flex-row col-lg-7"
              style={{ justifyContent: "flex-end" }}
            >
              <div
                className="mr-2 w-auto position-relative"
              >
                <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  value={searchData}
                  placeholder="Search..."
                  onChange={(e) => handleSearch(e)}
                  style={{ paddingLeft: "47px" }}
                />
                {/* </div> */}
              </div>
              <div className="form-group mr-1">
                <JobProgressFilter
                  setData={setData}
                  setOffset={setOffset}
                  openStatus={openStatus}
                  setOpenStatus={setOpenStatus}
                  openStatusValue={openStatusValue}
                  setOpenStatusValue={setOpenStatusValue}
                  setClearFilter={setClearFilter}
                  jobPriority={jobPriority}
                  setJobPriority={setJobPriority}
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className='mr-1'>
                <JobsSorting
                  handleSorting={handleSorting}
                  setToggle={setToggleSort}
                  toggle={toggleSort}
                  selectedData={sortByTargetEndDate?.value ? sortByTargetEndDate : (sortByJobType?.value ? sortByJobType : (sortByStatus?.value ? sortByStatus : (sortByClientCode?.value ? sortByClientCode : (sortByClientName?.value ? sortByClientName :  { name: "Recently Added/Modified First", value: "" }))))}
                />
              </div>
              {(
                <div className= "mr-2">
                  <JobProgressDownloadReport 
                  searchTerm={searchData} 
                  openStatus={openStatus}
                  sortByTargetEndDate={sortByTargetEndDate}
                  sortByJobType={sortByJobType}
                  sortByStatus={sortByStatus}
                  sortByClientCode={sortByClientCode}
                  sortByClientName={sortByClientName}
                  jobPriority={jobPriority}
                  />
                </div>
              )}
           
            </div>
          </div>
          <div className="row" style={{ width: "100%" }}>
            <div className="col-md-12">
              <JobProgressTable
                data={data}
                headers={JOB_PROGRESS_HEADERS?.filter((item:TableHeadersType)=>item?.value!=="checklist_status")}
                fetching={fetching}
                handleSetJobsData={handleSetJobsData}
                handleToggleProgressCommentsModal={
                  handleToggleProgressCommentsModal
                }
                type={"underline"}
                isAdminReport={true}
                isSuperAdmin={true}
                getJobId={getJobId}
                handleToggleLinkUploadModal={handleToggleLinkUploadModal}
                getShareJobId={getShareJobId}
                handleToggleShareJobModal={handleToggleShareJobModal}
              />
              <div style={{ display: fetching ? "none" : "inline" }}><ScrollToTop /></div>
              {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
            </div>
          </div>
        </div>
      </div>

      {fetching && offset === 0 && <Loader />}
      {handleErrorSuccessModal()}
      {showProgressCommentsModal && (
        <ProgressCommentsModal
          modal={showProgressCommentsModal}
          toggleModal={handleToggleProgressCommentsModal}
          data={jobsData}
          commentFetching={jobProgressCommentsFetching}
          jobProgressCommentsList={jobProgressComment}
          showClientName
          showDetails
          isAdmin
          showInputBox
          characterLength={150}
          handlePostComment={handleSubmitJobComment}
          commentsSuccess={jobProgressCommentsSuccess}
          jobPriority={jobPriority}



        />
      )}
      {showLinkUploadModal && (
        <LinkUploadModal
          modal={showLinkUploadModal}
          toggleModal={handleToggleLinkUploadModal}
          data={jobsData}
          showInputBox
          client_code={jobsData?.client_details?.client_code}
          setOpenStatus={setOpenStatus}
          setOpenStatusValue={setOpenStatusValue}
          company_name={jobsData?.client_details?.company_name}
          handleAddDocumentLink={handleSubmitDocumentLink}
          documentsLinkList={documentsLinkList}
          commentFetching={jobProgressCommentsFetching}
          title={getPage}
          filterStatus={openStatus}
          endDate={sortByTargetEndDate?.value}
          jobType={ sortByJobType?.value}
          status={sortByStatus?.value} 
          sortByClientCode={sortByClientCode?.value}
          clientName={sortByClientName?.value}
          searchData={searchData}
          jobPriority={jobPriority}
        />
        // 

      )}
      {showUsersWorkingOnJob && (
        <ShowUsersWorkingOnJobModal
          modal={showUsersWorkingOnJob}
          toggleModal={handleToggleUserWorkingOnJob}
          jobTypeId={jobTypeId}
          showUsersWorkingOnJobData={showUsersWorkingOnJobData}
        />

      )}
      {showShareJobsModal && (
        <ShowShareJobModal
          modal={showShareJobsModal}
          toggleModal={handleToggleShareJobModal}
          jobTypeId={jobTypeId}
          showUsersWorkingOnJobData={showUsersWorkingOnJobData}
          singleJobsData={singleJobsData}
          setOpenStatus={setOpenStatus}
          setJobProgressSearchData={setSearchData}
          setClearFilter={setClearFilter}
          searchData={searchData}
          openStatus={openStatus}
          sortByTargetEndDate={sortByTargetEndDate}
          sortByJobType={sortByJobType}
          sortByStatus={sortByStatus}
          sortByClientCode={sortByClientCode}
          sortByClientName={sortByClientName}
          dispatchGetAllOpenJobsListAction={dispatchGetAllOpenJobsListAction}
          listOffset={offset}
          listSetOffset={setOffset}
          jobPriority={jobPriority}

        />

      )}
      {/*  */}

      <Toaster />
      {/* {fetching && offset === 0 && <Loader />} */}

    </div>

  );
};

const mapStateToProps = (state: RootState) => ({
  fetching: state.jobs.fetching,
  token: state.auth.token,
  success: state.jobs.success,
  openJobsListing: state.jobs.jobsList,
  error: state.jobs.error,
  statusCode: state.jobs.statusCode,
  jobProgressCommentsFetching: state.jobs.jobProgressCommentsFetching,
  jobProgressCommentsList: state.jobs.jobProgressCommentsList,
  jobProgressCommentsSuccess: state.jobs.jobProgressCommentsSuccess,
  documentsLinkList: state.jobs.documentsLinkList,
  openJobsListingTotalCount: state.jobs.totalJobsCount,
  singleJobsData: state.jobs.singleJobs,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetListingError: () => dispatch(resetError()),
  dispatchResetListingSuccess: () => dispatch(resetSuccess()),
  dispatchResetOpenJobsList: () => dispatch(resetJobsList()),
  dispatchGetAllOpenJobsListAction: (data: any) =>
    dispatch(getJobsListAction(data)),
  dispatchResetJobProgressCommentsListing: () =>
    dispatch(resetJobProgressCommentsListing()),
  dispatchResetJobProgressCommentsSuccess: () =>
    dispatch(resetJobProgressCommentsSuccess()),
  dispatchGetAllJobProgressCommentsAction: (
    data: GetJobProgressCommentsPayload
  ) => dispatch(getJobCommentsDetailsAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetDocumentsLinkAction: (data: GetAllDocumentsLinkPayloadType) =>
    dispatch(getJobLinksDetailsAction(data)),
  dispatchAddDocumentLinkAction: (data: AddDocumentLinkPayloadType) =>
    dispatch(addJobLinkAction(data)),
  dispatchGetSingleJobsAction: (data: SingleJobPayload) => dispatch(getSingleJobsAction(data)),
  dispatchResetDocumentsLinkList: () => dispatch(resetDocumentsLinkList()),
  dispatchResetAllOpenItemsListTotelCount: () => dispatch(resetJobsTotalCount()),
  dispatchResetsingleJobsAction: () => dispatch(resetSingleJobs()),
  dispatchAddJobProgressCommentAction: (data: AddJobProgressCommentPayload) =>
  dispatch(addJobCommentsAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobProgressReports);
